import { MutationTree } from 'vuex';
import { ClinicalTrainingEventsState } from './types';
import { ClinicalTrainingEventsMutations } from './types';
import ClinicalTrainingEvent, { ClinicalTrainingEventModal } from './clinical-training-event';
import { ListStatus, EditableStatus } from '@/store/types';

export const mutations: MutationTree<ClinicalTrainingEventsState> = {
  [ClinicalTrainingEventsMutations.SET_ALL](state, events: ClinicalTrainingEventModal[]) {
    state.list = events;
  },

  [ClinicalTrainingEventsMutations.SET_ALL_STATUS](state, status: ListStatus) {
    state.listStatus = status;
  },

  [ClinicalTrainingEventsMutations.SET_LIST_PAGINATION](state, pagination) {
    state.listPagination = pagination;
  },

  [ClinicalTrainingEventsMutations.SET_EDITABLE](state, event: ClinicalTrainingEvent | null) {
    state.editable = event;
    if (event) {
      state.initialEditable = event.clone();
    } else {
      state.initialEditable = null;
    }
  },

  [ClinicalTrainingEventsMutations.SET_EDITABLE_STATUS](state, status: EditableStatus) {
    state.editableStatus = status;
  },

  [ClinicalTrainingEventsMutations.UPDATE_EDITABLE](state, changes) {
    if (state.editable) {
      Object.assign(state.editable, changes);
    }
  },

  [ClinicalTrainingEventsMutations.UPDATE_INITIAL_EDITABLE](state, changes) {
    if (state.initialEditable) {
      Object.assign(state.initialEditable, changes);
    }
  },

  [ClinicalTrainingEventsMutations.UPDATE_EVENT](state, { index, event }: { index: number; event: ClinicalTrainingEventModal }) {
    if (state.list[index]) {
      state.list.splice(index, 1, event);
    }
  },

  [ClinicalTrainingEventsMutations.SET_PRODUCTS](state, products) {
    state.products = products;
  },
};
